import { api } from "../lib/api";

// hairstyleTryOnEngine.generateThreePreviews(photo, styleDirection, occasion)
// Returns 3 previews generated on the SAME uploaded photo (Classic / Premium / Bold).
export async function generateThreePreviews(photo, styleDirection, occasion) {
  const image_base64 = (photo || "").split(",")[1] || photo;
  const { data } = await api.post("/ai/hairstyle-previews", {
    image_base64, styleDirection, occasion,
  });
  return data.previews; // [{ tier, name, confidence, reason, image }]
}
